var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('xlsx-workbook',[_c('xlsx-sheet',{attrs:{"collection":_vm.data,"sheet-name":_vm.widget.name}}),_c('xlsx-download',{attrs:{"filename":_vm.fileName}},[_c('b-button',{attrs:{"variant":"outline"}},[_c('b-icon-download')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }